import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Badge, Card, SelectField } from "../../../components/ui";
import { DataTable } from "../../../components/ui/table/DataTable";
import { AppShell } from "../../../layouts/AppShell";
import { listQuestionnaireVersions } from "../api/questionnaireAdminApi";
import {
  getSummary,
  listQuestionnaireMemberStatuses,
} from "../api/questionnaireResultsApi";

export function QuestionnaireResultsPage() {
  const [versionId, setVersionId] = useState("");
  const versions = useQuery({
    queryKey: ["questionnaire", "versions"],
    queryFn: listQuestionnaireVersions,
  });
  const summary = useQuery({
    queryKey: ["questionnaire", "summary", versionId],
    queryFn: () => getSummary(versionId || undefined),
  });
  const members = useQuery({
    queryKey: ["questionnaire", "member-statuses", versionId],
    queryFn: () => listQuestionnaireMemberStatuses(versionId || undefined),
  });
  return (
    <AppShell title="問卷結果" breadcrumb={["管理後台", "固定問卷", "結果"]}>
      <Card title="版本篩選">
        <SelectField
          label="問卷版本"
          value={versionId}
          onChange={(event) => setVersionId(event.target.value)}
        >
          <option value="">目前發布版本</option>
          {(versions.data ?? []).map((version) => (
            <option key={version.id} value={version.id}>
              V{version.versionNumber} - {version.title}
            </option>
          ))}
        </SelectField>
      </Card>
      <Card title="完成填答">
        <p className="display-4">{summary.data?.completedCount ?? 0}</p>
        <p>
          目前檢視版本：V{summary.data?.versionNumber ?? "?"}。以下僅為意見分布，不是分數、考試結果或排名。
        </p>
      </Card>
      {summary.data?.distributions.map((distribution) => (
        <Card
          key={distribution.questionKey}
          title={`${distribution.questionCode} ${distribution.prompt}`}
        >
          <ul>
            {distribution.buckets.map((bucket) => (
              <li key={String(bucket.value)}>
                {bucket.label}：{bucket.count}
              </li>
            ))}
          </ul>
        </Card>
      ))}
      <DataTable
        caption="會員填答狀態"
        loading={members.isLoading}
        error={members.isError ? "無法載入會員填答狀態" : undefined}
        rows={members.data?.items ?? []}
        rowKey={(row) => row.member.id}
        columns={[
          {
            id: "member",
            header: "會員",
            cell: (row) => (
              <>
                <div>{row.member.registrantName}</div>
                <div className="small text-muted">{row.member.username}</div>
              </>
            ),
          },
          {
            id: "company",
            header: "公司",
            cell: (row) => row.member.companyName ?? "—",
          },
          {
            id: "status",
            header: "填答狀態",
            cell: (row) => (
              <Badge
                variant={row.submissionStatus === "COMPLETED" ? "success" : "secondary"}
              >
                {row.submissionStatus === "COMPLETED" ? "已填寫" : "尚未填寫"}
              </Badge>
            ),
          },
          {
            id: "submitted",
            header: "送出時間",
            cell: (row) =>
              row.submittedAt ? new Date(row.submittedAt).toLocaleString() : "—",
          },
          {
            id: "view",
            header: "操作",
            cell: (row) =>
              row.submissionId ? (
                <Link to={`/admin/questionnaire/submissions/${row.submissionId}`}>
                  查看填寫內容
                </Link>
              ) : (
                <span className="text-muted">尚無內容</span>
              ),
          },
        ]}
      />
    </AppShell>
  );
}
